import createReducer from '../../../../helpers/createReducer';
import { fetchGuestAuditLogs } from '../../../sagas/routines';
import { clearGuestAuditLogs } from '../../actions/audit-log';

const initialState = {
  all: [],
  meta: { page: 1, total: 0 },
  fetching: false,
  fetched: false
};

const fetchGuestAuditLogsHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: [...state.all, ...response.items],
    meta: response.meta
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearGuestAuditLogsHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchGuestAuditLogsHandler(fetchGuestAuditLogs),
  ...clearGuestAuditLogsHandler(clearGuestAuditLogs)
});
